import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow",
  "use": "icon-arrow-usage",
  "viewBox": "0 0 12 7",
  "content": "<symbol viewBox=\"0 0 12 7\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow\"><path clip-rule=\"evenodd\" d=\"M0.29271 0.292893C0.683234 -0.0976311 1.3164 -0.0976311 1.70692 0.292893L5.99982 4.58579L10.2927 0.292893C10.6832 -0.0976311 11.3164 -0.0976311 11.7069 0.292893C12.0974 0.683417 12.0974 1.31658 11.7069 1.70711L6.70692 6.70711C6.3164 7.09763 5.68323 7.09763 5.29271 6.70711L0.29271 1.70711C-0.0978142 1.31658 -0.0978142 0.683417 0.29271 0.292893Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol